import React from "react";
import { useTranslation } from "react-i18next";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

export function Carousel() {
  const { t } = useTranslation();

  return (
    <div className="container-fluid p-0">
      <div id="header-carousel" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          {/* Slide 1 */}
          <div className="carousel-item active">
            <img
              className="d-block w-100"
              src={require("../imagenes/carousel-1.jpg")}
              alt="Slide 1"
            />
            <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
              <div className="p-3" style={{ maxWidth: "900px" }}>
                <h2 className="text-white text-uppercase mb-md-3">{t("carrusel_ahorro")}</h2>
                <h1 className="display-3 text-white mb-md-4"></h1>
              </div>
            </div>
          </div>

          {/* Slide 2 */}
          <div className="carousel-item">
            <img
              className="d-block w-100"
              src={require("../imagenes/carousel-2.jpg")}
              alt="Slide 2"
            />
            <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
              <div className="p-3" style={{ maxWidth: "900px" }}>
                <h2 className="text-white text-uppercase mb-md-3">{t("private_transfer_and_tours")}</h2>
                <h1 className="display-3 text-white mb-md-4"></h1>
              </div>
            </div>
          </div>
        </div>

        {/* Controls */}
        <button className="carousel-control-prev" type="button" data-bs-target="#header-carousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>

        <button className="carousel-control-next" type="button" data-bs-target="#header-carousel" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
}
